module.exports = __webpack_public_path__ + "static/media/sky.b9188f00.MOV";